import { Report } from 'dashboard/models/report';
import { ReportTemplate } from 'dashboard/models/report-template';
import { Tag } from 'dashboard/models/tag';
import ReportDetailsSummary from 'dashboard/modules/ResourceReport/ReportDetailsSummary';
import { FeatureFlagsMap } from 'lib/interfaces/feature-flags';

interface ResourceReportProps {
  report: Report;
  reportTemplate: ReportTemplate | undefined;
  defaultAccordionOpen: boolean;
  featureFlags: FeatureFlagsMap;
  tags?: Tag[];
  showConnectedReportMenu?: boolean;
  handleUpdateReportTags?: (reportId: string, tags: string[]) => void;
}

const ResourceReport = ({
  report,
  reportTemplate,
  defaultAccordionOpen,
  featureFlags,
  tags,
  showConnectedReportMenu = true,
  handleUpdateReportTags,
}: ResourceReportProps) => {
  return (
    <ReportDetailsSummary
      report={report}
      reportTemplate={reportTemplate}
      tags={tags}
      featureFlags={featureFlags}
      isRedacted={!!report.attributes['redacted-at']}
      accordion={true}
      isDefaultOpen={defaultAccordionOpen}
      showConnectedReportMenu={showConnectedReportMenu}
      handleUpdateReportTags={handleUpdateReportTags}
    />
  );
};

export default ResourceReport;
